import { useState, useRef } from "react";
import Config from "../../Config.js";

import d_sniadanie_1 from "../../book/d_sniadanie1.png";
import d_sniadanie_2 from "../../book/d_sniadanie2.png";
import d_obiad_1 from "../../book/d_obiad1.png";
import d_obiad_2 from "../../book/d_obiad2.png";
import d_podwieczorek from "../../book/d_podwieczorek.png";
import d_spacer from "../../book/d_spacer.png";
import d_plac_zabaw from "../../book/d_plac_zabaw.png";
import d_sen from "../../book/d_sen.png";

import book_ok from "../../book/book_smile.png";
import book_neutral from "../../book/book_neutral.png";
import book_bad from "../../book/book_bad.png";

import BookGroup from "./BookGroup.js";
import BookKid from "./BookKid.js";

import Calendar from "../../calendar/Calendar";

import InputPagger from "../../helpers/InputPagger.js";

import gochat from "../../gochat.png";


import InputTextAlpha from "../../helpers/InputTextAlpha.js";
import InputCombo from "../../helpers/InputCombo.js";
import InputLegend from "../../helpers/InputLegend.js";
import InputComboGrupa from "../../helpers/InputComboGrupaE.js";


//import KidDelete from "./KidDelete";
import AlertsNew from "./AlertsNew.js";

//import Start from "./Start";
import QuickChat from "../msgE/QuickChat.js";
import SortBy from "../../helpers/SortBy.js";
import MenuTable from "../../helpers/MenuTable.js";
//import KidDeleteMass from "./KidDeleteMass";


function Book(props)
{
    //do przemyślenia
    var cData = Config.getFromBuffer(Config.cache_grups_emps,3600, props.userData );
    
    const [gr, setGr] = useState(cData);
    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [refresh, setRefresh] = useState(0);


    const [filter, setFilter] = useState(null);
    

    
    var dt = new Date();

    var strM = (dt.getMonth()+1)+"";
    if(strM.length == 1) strM = "0" + strM;
 
    var strD = dt.getDate()+"";
    if(strD.length == 1) strD = "0" + strD;

    var dateX  = dt.getFullYear()+"-"+strM+"-"+strD;

    const [filterParam, setFilterParam] = useState({   
        d_imie_nazwisko:  props.mainView.readFilter('d_imie_nazwisko',''),
        p_grupa_id: '_x_',
        archiwalne: props.mainView.readFilter('archiwalne','0'),
        day: dateX,
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);


    
    const tabRef = useRef(0); //do druku

    
    const [params, setParams] = useState([
        {
            view:'def',
            id:'',
            group_id: '',
            type: '',
            kids:'',
        },
    ]);

    const getGr = () => {
       
 
        props.mainView.setProgress(-2);
    
       
    
        fetch( Config.url + '/rest_v1_employessModule,gr', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 
    
                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setGr(res.result);      
                        
                        Config.setToBuffer(Config.cache_grups, res.result, props.userData);
                                
                    }
    
            } )
            .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
            });
                   
    
            return false;
    }

    
    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_employessModule,kidsE_book', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {

                        setGr(res.result_gr);      
                        setTab(res.result);            

                        Config.setToBuffer(Config.cache_grups, res.result_gr, props.userData);    

                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                p_grupa_id: item.p_grupa_id	,
                                title: item.imie  + "  " + item.nazwisko,
                                selected: 0,
                            });
                        } )

                        setSelectedRow(newSelector);
                        
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    

    if(tab == null)
        {
            setTab([]);
            setGr([]);
            getTab();
            //setView('link');       
    
            return <div>
                ...
            </div>
        }



    //-------------------------------------------------------
//-------------------------------------------------------
//MASS



  

    const valChangeListener = (typ,value,id) => {

        var tmpTab = tab;

        var znalezionyElement = tmpTab.find(element => element.id === id);
        
        if(znalezionyElement!==undefined)
        {
            znalezionyElement.dziennik[typ] = value;
            setTab(tmpTab);
            setRefresh(refresh + 1);

            
        }
    }

    const filterChangeListener = (filedName, val, correct, msg) => {

       
        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        var modX = val.length % 3;
        if(  val.length == 0 || modX == 0 || msg =='combo')
        //  
        

        props.mainView.writeFilter(filedName, val);
    }
    

    const goNextNew = () => {
        
        setTab(null);    
    }

    

    const filterClear = () => {

        props.mainView.writeFilter('d_imie_nazwisko', '');
        props.mainView.writeFilter('p_group_id', '_x_');
        props.mainView.writeFilter('archiwalne', '0');

        setFilterParam({ 
            d_imie_nazwisko: '', 
            p_grupa_id: '_x_',
            archiwalne: 0,    
            day: dateX,
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },


            limit: 50,
            page: 1,
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

  

    const onBack = ( ) => {                
        
        setParams({
            view:'def',
            id:'',
            group_id: '',
            type: '',
            kids:'',
        });
        
        setTab(null); 
        //setView('link');  
        
    }

    const changeView = (e) => {
        
        var atr_id          = e.target.getAttribute('atr-id');   
        var atr_grupa_id    = e.target.getAttribute('atr-grupa-id');   
        var atr_typ    = e.target.getAttribute('atr-typ');   
        var atr_view    = e.target.getAttribute('atr-view');   




        setParams( {...params, ['id']:atr_id,['grupa_id']:atr_grupa_id,['type']:atr_typ,['view']:atr_view} );   
    }

    var dlg = '';

    if(params.view!=='def')
    {
        if(params.view=='show_grupa')
        {   
            var grupa_dzieci = tab.filter(tab => tab.p_grupa_id === params.grupa_id);
            var grupa = gr.filter(grup => grup.v === params.grupa_id);
         
            if(params.type=='sniadanie_1') var type = "Pierwsze śniadanie";
            if(params.type=='sniadanie_2') var type = "Drugie śniadanie";
            if(params.type=='obiad_danie_1') var type = "Obiad - pierwsze danie";
            if(params.type=='obiad_danie_2') var type = "Obiad - drugie danie";
            if(params.type=='podwieczorek') var type = "Podwieczorek";
            if(params.type=='spacer') var type = "Spacer";
            if(params.type=='plac_zabaw') var type = "Plac zabaw";
            if(params.type=='sen') var type = "Drzemka";

            var title = grupa[0].title+' / '+filterParam.day+' / '+type;

            dlg = <BookGroup mainView={props.mainView} userData={props.userData} refresh={refresh} onBack={onBack}  tab={tab} valChange={valChangeListener} gr={gr} params={params} view={params.view} typ={params.type} grupa_id={params.grupa_id} id={params.id} title={title} />
        }

        if(params.view=='show_kid')
            {   
                var kid_data = tab.filter(tab => tab.id === params.id);
                //var grupa = gr.filter(grup => grup.v === params.grupa_id);
             
                
    
                var title = kid_data[0].imie+' '+kid_data[0].nazwisko+' / '+filterParam.day;
    
                dlg = <BookKid mainView={props.mainView} userData={props.userData} refresh={refresh} onBack={onBack}  kid={kid_data} valChange={valChangeListener} view={params.view} typ={params.type} grupa_id={params.grupa_id} id={params.id} title={title} />
            }
    }

    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            //setView('link');
    
            var zaznaczonych = 0;
            var arrSelected = new Array();         
            for(var s=0; s<selectedRow.length; s++)
            {
                if(selectedRow[s].selected == 1) 
                {
                    zaznaczonych ++;
                    arrSelected.push( selectedRow[s] );                    
                }
            }
        }

        const clickOnDay = (date,title) => {      
      
            if( date != null && date.length > 2)
            {
               
                setFilterParam({...filterParam, ["day"]: date,["p_grupa_id"]:'_x_' });    
                setTab(null);
               //get(date);
            }
          
      
        }    

    


    
    

    var daysReview = new Array();

   daysReview.push({
         date: filterParam.day,
         title: "wybrano " + filterParam.day,
         className: "selected",
   });
    
    


    




    var sortList = [                
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "dziecko_nazwisko", name: "Nazwisko"  },
]

 

    var xwindow = null;

    var is_mobile = props.mainView.isMobile();

   


        var zaznaczonych = 0;
        for(var s=0; s<selectedRow.length; s++)
        {
            if(selectedRow[s].selected == 1) zaznaczonych ++;
        }

    

    var table = '';    
    var calendar = '';    
   
    console.log("XXXX", gr);
        
    if(is_mobile)
    {   
        calendar = <div className="block50 ">

        <Calendar tab={daysReview} clickOnDay={clickOnDay} />

        </div>

        table = gr.map( (grupa, ix) => {

                var grupa_dzieci = tab.filter(tab => tab.grupa === grupa.title)

                if(grupa.v!='_x_')

                if(filterParam.p_grupa_id=='_x_' || filterParam.p_grupa_id==grupa.v)    
                {
                    
                    return <div className='mobile_table'>

                    

                    <div className="mobile_th">{grupa.title}  ({grupa_dzieci.length})  </div>
                    <div className="mobile_th_light">
                        <div className="book_row_img">
                            <img src={d_sniadanie_1} atr-grupa-id={grupa.v} atr-id='0' atr-typ='sniadanie_1' atr-view="show_grupa" onClick={changeView} className="book_img" title="Pierwsze śniadanie"/>
                            <img src={d_sniadanie_2} atr-grupa-id={grupa.v} atr-id='0' atr-typ='sniadanie_2' atr-view="show_grupa" onClick={changeView} className="book_img" title="Drugie śniadanie"/>
                            <img src={d_obiad_1} atr-grupa-id={grupa.v} atr-id='0' atr-typ='obiad_danie_1' atr-view="show_grupa" onClick={changeView} className="book_img" title="Obiad pierwsze danie"/>
                            <img src={d_obiad_2} atr-grupa-id={grupa.v} atr-id='0' atr-typ='obiad_danie_2' atr-view="show_grupa" onClick={changeView} className="book_img" title="Obiad drugie danie"/>
                            <img src={d_podwieczorek} atr-grupa-id={grupa.v} atr-id='0' atr-typ='podwieczorek' atr-view="show_grupa" onClick={changeView} className="book_img" title="Podwieczorek"/>
                            <img src={d_spacer} atr-grupa-id={grupa.v} atr-id='0' atr-typ='spacer' atr-view="show_grupa" onClick={changeView} className="book_img" title="Spacer"/>
                            <img src={d_plac_zabaw} atr-grupa-id={grupa.v} atr-id='0' atr-typ='plac_zabaw' atr-view="show_grupa" onClick={changeView} className="book_img" title="Plac zabaw"/>
                            <img src={d_sen} atr-grupa-id={grupa.v} atr-id='0' atr-typ='sen' atr-view="show_grupa" onClick={changeView} className="book_img" title="Sen"/>
                        </div>
                    </div>
                        <div className="mobile_tb">
                        {
                            grupa_dzieci.map( (dziecko, ix2) => {

                                var dziennik = '';
                                 
                                    if(dziecko.dziennik.id!='') dziennik = <div className='kid_row_cell link_normal item_5'><img src={book_neutral} atr-grupa-id={grupa.v} atr-id={dziecko.id} atr-view="show_kid" onClick={changeView} className="set_book_img" title="Sen"/></div>

                                    return <div className='kid_row'>
                                        <div className='kid_row_cell link_normal item_5'>
                                            {ix2+1}.
                                        </div>
                                        <div className='kid_row_cell item_80' atr-id={dziecko.id} atr-view="show_kid" onClick={changeView} >{dziecko.imie} {dziecko.nazwisko}</div>
                                        {dziennik}
                                       
                                        
                                        
                                    </div>
                                
                            })
                        }    
                        </div>
                    </div>
                }
                
                

            }
        )
    
    }
    else
    {   
        calendar = <div className="block50 goRightFL">

        <Calendar tab={daysReview} clickOnDay={clickOnDay} />

        </div>

        table = gr.map( (grupa, ix) => {

            var grupa_dzieci = tab.filter(tab => tab.grupa === grupa.title)

            if(grupa.v!='_x_')

            if(filterParam.p_grupa_id=='_x_' || filterParam.p_grupa_id==grupa.v)    
            {
                
                return <div className='book_table'>

                

                <div className="book_th">{grupa.title}  ({grupa_dzieci.length})  </div>
                <div className="book_th_light">
                    <div className="book_row_img">
                        <img src={d_sniadanie_1} atr-grupa-id={grupa.v} atr-id='0' atr-typ='sniadanie_1' atr-view="show_grupa" onClick={changeView} className="book_img" title="Pierwsze śniadanie"/>
                        <img src={d_sniadanie_2} atr-grupa-id={grupa.v} atr-id='0' atr-typ='sniadanie_2' atr-view="show_grupa" onClick={changeView} className="book_img" title="Drugie śniadanie"/>
                        <img src={d_obiad_1} atr-grupa-id={grupa.v} atr-id='0' atr-typ='obiad_danie_1' atr-view="show_grupa" onClick={changeView} className="book_img" title="Obiad pierwsze danie"/>
                        <img src={d_obiad_2} atr-grupa-id={grupa.v} atr-id='0' atr-typ='obiad_danie_2' atr-view="show_grupa" onClick={changeView} className="book_img" title="Obiad drugie danie"/>
                        <img src={d_podwieczorek} atr-grupa-id={grupa.v} atr-id='0' atr-typ='podwieczorek' atr-view="show_grupa" onClick={changeView} className="book_img" title="Podwieczorek"/>
                        <img src={d_spacer} atr-grupa-id={grupa.v} atr-id='0' atr-typ='spacer' atr-view="show_grupa" onClick={changeView} className="book_img" title="Spacer"/>
                        <img src={d_plac_zabaw} atr-grupa-id={grupa.v} atr-id='0' atr-typ='plac_zabaw' atr-view="show_grupa" onClick={changeView} className="book_img" title="Plac zabaw"/>
                        <img src={d_sen} atr-grupa-id={grupa.v} atr-id='0' atr-typ='sen' atr-view="show_grupa" onClick={changeView} className="book_img" title="Sen"/>
                    </div>
                </div>
                    <div className="book_tb">
                    {
                        grupa_dzieci.map( (dziecko, ix2) => {

                            var dziennik = '';
                             
                                if(dziecko.dziennik.id!='') dziennik = <div className='kid_row_cell link_normal item_5 goRightFL'><img src={book_neutral} atr-grupa-id={grupa.v} atr-id={dziecko.id} atr-view="show_kid" onClick={changeView} className="set_book_img" title="Sen"/></div>

                                return <div className='kid_row'>
                                    <div className='kid_row_cell link_normal item_5'>
                                        {ix2+1}.
                                    </div>
                                    <div className='kid_row_cell item_90'  atr-id={dziecko.id} atr-view="show_kid" onClick={changeView} >{dziecko.imie} {dziecko.nazwisko}</div>
                                    {dziennik}
                                   
                                    
                                    
                                </div>
                            
                        })
                    }    
                    </div>
                </div>
            }
            
            

        }
    )
    }    
    

    return (

        <div className="view_content">
            
            {xwindow}
            {dlg}
           


            <div className="table_filter mobile_filters">
                            <div className="filter_controll">   
                                <label>Grupa: </label>                             
                                <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={filterChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                            </div> 

               
                           <div className="filter_controll">   
                                <label>Dziecko: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={filterChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                            </div>  
 
                        



                            <div className="filter_btn">
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>
                            
            </div>
            

            <div className="bg_center">
                
                {calendar}
                
                {table}        
            </div>


        </div>

    )

}

export default Book;